import { render, staticRenderFns } from "./AbkList.vue?vue&type=template&id=a5491dc6&scoped=true&"
import script from "./AbkList.vue?vue&type=script&lang=js&"
export * from "./AbkList.vue?vue&type=script&lang=js&"
import style0 from "./AbkList.vue?vue&type=style&index=0&id=a5491dc6&scoped=true&lang=scss&"
import style1 from "./AbkList.vue?vue&type=style&index=1&id=a5491dc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5491dc6",
  null
  
)

export default component.exports